import React from 'react'
import { Container, Paper, Grid, Text, Col } from '@mantine/core'
import useTranslation from 'next-translate/useTranslation'

const AcademicIntegrityContent = () => {
  const { lang } = useTranslation()
  return (
    <>
      {lang === 'en' ? (
        <Container size="sm">
          <Paper py="lg">
            <Grid gutter="md">
              <Grid.Col span={12}>
                <Text size="lg" weight="bold">
                  Academic Integrity in the Educational Environment at Infinity
                  Medical Academy
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Academic integrity in the educational environment refers to
                  the commitment to intellectual honesty and the ethical use and
                  dissemination of information, ensuring respect for
                  intellectual property rights. At Infinity Medical Academy,
                  this principle is integral to all aspects of its educational
                  activities, particularly in the context of e-learning and
                  distance learning programs.
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Key Aspects of Academic Integrity
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Intellectual and Scientific Honesty:</strong>{' '}
                      Upholding truthfulness in the creation and sharing of
                      knowledge. Ensuring that all information disseminated is
                      accurate, credible, and properly attributed.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Respect for Intellectual Property:</strong>{' '}
                      Recognizing and honoring the intellectual contributions of
                      others. Properly citing sources and avoiding plagiarism in
                      all digital educational materials.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>
                        Ethical Use and Dissemination of Information:
                      </strong>{' '}
                    </Text>
                    <ul
                      style={{
                        listStyle: 'inherit',
                        // margin: '16px 0px',
                        padding: '0px 0px 0px 40px',
                      }}
                    >
                      <li>
                        <Text size="md">
                          Ensuring that all content, whether texts, images,
                          programs, or designs, is used legally and ethically.
                        </Text>
                      </li>
                      <li>
                        <Text size="md">
                          Adhering to copyright laws and licensing agreements
                          when designing and uploading materials.
                        </Text>
                      </li>
                      <li>
                        <Text size="md">
                          Commitment to Academic Integrity at Infinity Medical
                          Academy
                        </Text>
                      </li>
                    </ul>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Policy Development:</strong> The Academy develops
                      and implements comprehensive policies to promote academic
                      integrity. These policies guide the creation, use, and
                      dissemination of digital educational materials.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Systems for Ensuring Integrity:</strong>
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          <Text size="md">
                            <strong>Attendance Monitoring:</strong> Systems are
                            in place to track trainee attendance, ensuring that
                            they meet the required 70% attendance rate for total
                            activity hours.
                          </Text>
                        </li>
                        <li>
                          <Text size="md">
                            <strong>Grade Monitoring:</strong> Continuous
                            evaluation of trainee performance and grades.
                          </Text>
                        </li>
                        <li>
                          <Text size="md">
                            <strong>Trainer Evaluation:</strong> Assessing
                            trainee satisfaction with each trainer to ensure
                            quality instruction.
                          </Text>
                        </li>
                        <li>
                          <Text size="md">
                            <strong>Certificate Issuance:</strong> Providing
                            certificates of attendance based on completion of
                            course requirements and adherence to integrity
                            standards.
                          </Text>
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Foundation of Integrity in Training:</strong>{' '}
                      Trainees are expected to actively participate in
                      development training courses and practical applications
                      designed by the trainer. Emphasizing the importance of
                      honesty and engagement in the learning process to ensure
                      meaningful and effective education.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>
                        Academic Integrity in E-Learning and Distance Learning:
                      </strong>
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 0px 0px 40px',
                        }}
                      >
                        <li>
                          <Text size="md">
                            <strong>
                              Design and Upload of Digital Content:
                            </strong>{' '}
                            Ensuring that all digital educational materials
                            comply with intellectual property rights. Utilizing
                            licensed content and properly attributing all
                            sources used in educational resources.
                          </Text>
                        </li>
                        <li>
                          <Text size="md">
                            <strong>
                              Qualification and Evaluation of Trainees:
                            </strong>{' '}
                            Implementing robust systems to qualify trainees,
                            ensuring they meet learning objectives and
                            performance standards. Monitoring and evaluating
                            trainee satisfaction and performance to maintain
                            high educational standards.
                          </Text>
                        </li>
                        <li>
                          <Text size="md">
                            <strong>Attendance and Participation:</strong>{' '}
                            Reinforcing the importance of attending and
                            participating in training activities. Ensuring that
                            attendance and engagement are tracked accurately to
                            maintain the integrity of the training process.
                          </Text>
                        </li>
                      </ul>
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Principles of Academic Integrity at Infinity Medical Academy
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="md">
                  Infinity Medical Academy is committed to upholding the highest
                  standards of academic integrity through a set of well-defined
                  principles and obligations. These principles ensure that the
                  educational process is credible, ethical, and effective in
                  achieving its learning outcomes.
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Customer Satisfaction Evaluation:</strong>{' '}
                      Implementation: Providing a customer satisfaction
                      evaluation form to assess the acquired skills and outcomes
                      of the educational process. Purpose: To continuously
                      improve the quality of education and ensure that learning
                      objectives are met.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Technical Support:</strong> Implementation:
                      Offering technical support to trainees to help them
                      understand the requirements for maintaining academic
                      integrity. Purpose: To prevent academic misconduct by
                      ensuring that trainees are aware of the consequences of
                      failing to maintain academic integrity.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Education Management System:</strong>{' '}
                      Implementation: Utilizing an education management system
                      to facilitate appropriate education via e-learning
                      platforms. Purpose: To support trainees in fulfilling
                      academic expectations regarding honesty and integrity.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Training Needs Model:</strong> Implementation:
                      Providing a training needs model for trainees to identify
                      and meet their educational needs. Purpose: To tailor
                      training programs to the specific needs of trainees,
                      enhancing their professional development.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Obligations to Maintain Academic Integrity
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Content Preparation Standards:</strong> Commitment
                      to preparing content that aligns with the educational
                      objectives and outcomes set by the center.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Scientific and Clinical References:</strong>{' '}
                      Trainers must refer to credible scientific sources and
                      clinical research to ensure the accuracy and reliability
                      of the information provided.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Intellectual Property Rights:</strong> Trainers
                      are required to respect intellectual property rights,
                      ensuring that all materials used are properly attributed
                      and legally compliant.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Disclosure of Conflicts of Interest:</strong>{' '}
                      Trainers must disclose any potential conflicts of interest
                      to maintain transparency and trust.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Non-Commercial Educational Activities:</strong>{' '}
                      Trainers must ensure that educational activities are free
                      from advertising, marketing, or promotion of commercial
                      products.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Interactive Engagement:</strong> Trainers are
                      committed to answering and interacting with attendees'
                      inquiries, fostering an engaging and supportive learning
                      environment.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>

              <Grid.Col span={12}>
                <Text size="lg" weight={500}>
                  Commitments to Ensure Academic Integrity in E-Learning
                  Programs
                </Text>
              </Grid.Col>

              <Grid.Col span={12}>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 0px 0px 40px',
                  }}
                >
                  <li>
                    <Text size="md">
                      <strong>Accuracy of Data:</strong> Trainees must verify
                      the accuracy of their data before submitting payment to
                      ensure correct processing and record-keeping.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Understanding Policies and Conditions:</strong>{' '}
                      Trainees are required to read and understand the policies,
                      terms, and conditions before completing the payment
                      process to ensure compliance and awareness of their
                      responsibilities.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>
                        Attendance and Certification Requirements:
                      </strong>{' '}
                      Trainees must read and comprehend the attendance
                      percentage required to obtain the certificate and the
                      necessary educational hours before making a payment to
                      ensure they meet all requirements.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Customer Satisfaction Evaluation:</strong> A form
                      is provided to trainees to evaluate their satisfaction
                      with the course, aiding in the continuous improvement of
                      quality and educational outcomes.
                    </Text>
                  </li>
                  <li>
                    <Text size="md">
                      <strong>Training Needs Identification:</strong> Trainees
                      are given a training needs identification form to specify
                      the activities they wish to develop, enabling the center
                      to address their training needs effectively.
                    </Text>
                  </li>
                </ul>
              </Grid.Col>
              <Grid.Col span={12}>
                <Text size="md">
                  Academic integrity is a fundamental principle at Infinity
                  Medical Academy, encompassing various aspects from content
                  preparation to trainee participation. By adhering to these
                  principles and commitments, the Academy ensures a trustworthy,
                  ethical, and high-quality educational environment that
                  supports the professional development of healthcare
                  practitioners. This comprehensive approach not only fosters
                  academic honesty but also enhances the overall learning
                  experience, ensuring that trainees receive the best possible
                  education.
                </Text>
              </Grid.Col>
            </Grid>
          </Paper>
        </Container>
      ) : (
        <Container size="lg">
          <Grid>
            <Col span={12}>
              <>
                <Text size="lg" weight={700} style={{ margin: '1rem 0' }}>
                  النزاهة الأكاديمية في البيئة التعليمية
                </Text>
                <Text style={{ margin: '1rem 0' }}>
                  تشير النزاهة الأكاديمية في البيئة التعليمية إلى الالتزام
                  بالأمانة الفكرية والاستخدام الأخلاقي للمعلومات ونشرها، بما
                  يضمن احترام حقوق الملكية الفكرية. وفي أكاديمية إنفينيتي
                  الطبية، يعد هذا المبدأ جزءًا لا يتجزأ من جميع جوانب أنشطتها
                  التعليمية، لا سيما في سياق برامج التعلم الإلكتروني والتعليم عن
                  بعد.
                </Text>
                <Text size="lg" weight={700} style={{ margin: '1rem 0' }}>
                  الجوانب الرئيسية للنزاهة الأكاديمية
                </Text>
                <ol
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text>
                      الصدق الفكري والعلمي:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>التمسك بالصدق في خلق المعرفة ومشاركتها.</li>
                        <li>
                          التأكد من أن جميع المعلومات المنشورة دقيقة وذات
                          مصداقية ومنسوبة بشكل صحيح.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      احترام الملكية الفكرية:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>الاعتراف وتكريم المساهمات الفكرية للآخرين.</li>
                        <li>
                          الاستشهاد بالمصادر بشكل صحيح وتجنب الانتحال في جميع
                          المواد التعليمية الرقمية.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      الاستخدام الأخلاقي ونشر المعلومات:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          التأكد من أن جميع المحتويات، سواء كانت نصوص أو صور أو
                          برامج أو تصميمات، يتم استخدامها بشكل قانوني وأخلاقي.
                        </li>
                        <li>
                          الالتزام بقوانين حقوق النشر واتفاقيات الترخيص عند
                          تصميم المواد وتحميلها.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      تطوير السياسات:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          تقوم الأكاديمية بتطوير وتنفيذ سياسات شاملة لتعزيز
                          النزاهة الأكاديمية.
                        </li>
                        <li>
                          توجه هذه السياسات عملية إنشاء واستخدام ونشر المواد
                          التعليمية الرقمية.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      أنظمة ضمان النزاهة:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          مراقبة الحضور: تم وضع أنظمة لتتبع حضور المتدربين،
                          والتأكد من استيفائهم لمعدل الحضور المطلوب وهو 70%
                          لإجمالي ساعات النشاط.
                        </li>
                        <li>
                          مراقبة الدرجات: التقييم المستمر لأداء المتدربين
                          ودرجاتهم.
                        </li>
                        <li>
                          تقييم المدرب: تقييم رضا المتدربين عن كل مدرب لضمان
                          جودة التعليم.
                        </li>
                        <li>
                          إصدار الشهادة: تقديم شهادات الحضور بناءً على استكمال
                          متطلبات الدورة والالتزام بمعايير النزاهة.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      أسس النزاهة في التدريب:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          من المتوقع أن يشارك المتدربون بفعالية في الدورات
                          التدريبية التطويرية والتطبيقات العملية التي صممها
                          المدرب.
                        </li>
                        <li>
                          التأكيد على أهمية الصدق والمشاركة في عملية التعلم
                          لضمان تعليم هادف وفعال.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      النزاهة الأكاديمية في التعلم الإلكتروني والتعليم عن بعد:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>تصميم وتحميل المحتوى الرقمي:</li>
                        <ul
                          style={{
                            listStyle: 'inherit',
                            // margin: '16px 0px',
                            padding: '0px 40px 0px 0px',
                          }}
                        >
                          <li>
                            التأكد من أن جميع المواد التعليمية الرقمية تتوافق مع
                            حقوق الملكية الفكرية.
                          </li>
                          <li>
                            الاستفادة من المحتوى المرخص وإسناد جميع المصادر
                            المستخدمة في الموارد التعليمية بشكل صحيح.
                          </li>
                        </ul>
                        <li>تأهيل وتقييم المتدربين:</li>
                        <ul
                          style={{
                            listStyle: 'inherit',
                            // margin: '16px 0px',
                            padding: '0px 40px 0px 0px',
                          }}
                        >
                          <li>
                            تنفيذ أنظمة قوية لتأهيل المتدربين، وضمان تحقيق أهداف
                            التعلم ومعايير الأداء.
                          </li>
                          <li>
                            رصد وتقييم رضا وأداء المتدربين للحفاظ على مستويات
                            تعليمية عالية.
                          </li>
                        </ul>
                        <li>الحضور والمشاركة:</li>
                        <ul
                          style={{
                            listStyle: 'inherit',
                            // margin: '16px 0px',
                            padding: '0px 40px 0px 0px',
                          }}
                        >
                          <li>
                            تعزيز أهمية الحضور والمشاركة في الأنشطة التدريبية.
                          </li>
                          <li>
                            التأكد من أن الحضور والمشاركة يتم تتبعها بدقة للحفاظ
                            على سلامة عملية التدريب.
                          </li>
                        </ul>
                      </ul>
                    </Text>
                  </li>
                </ol>

                <Text size="lg" weight={700} style={{ margin: '1rem 0' }}>
                  مبادئ النزاهة الأكاديمية في أكاديمية إنفينيتي الطبية
                </Text>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text>
                      تقييم رضا العملاء:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          التنفيذ: توفير استمارة تقييم رضا العملاء لتقييم
                          المهارات المكتسبة ومخرجات العملية التعليمية.
                        </li>
                        <li>
                          الغرض: التحسين المستمر لجودة التعليم والتأكد من تحقيق
                          أهداف التعلم.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      دعم فني:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          التنفيذ: تقديم الدعم الفني للمتدربين لمساعدتهم على فهم
                          متطلبات الحفاظ على النزاهة الأكاديمية.
                        </li>
                        <li>
                          الغرض: منع سوء السلوك الأكاديمي من خلال التأكد من أن
                          المتدربين على دراية بعواقب الفشل في الحفاظ على النزاهة
                          الأكاديمية.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      نظام إدارة التعليم:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          التنفيذ: الاستفادة من نظام إدارة التعليم لتسهيل
                          التعليم المناسب عبر منصات التعلم الإلكتروني.
                        </li>
                        <li>
                          الغرض: دعم المتدربين في تحقيق التوقعات الأكاديمية فيما
                          يتعلق بالصدق والنزاهة.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      نموذج الاحتياجات التدريبية:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          التنفيذ: تقديم نموذج الاحتياجات التدريبية للمتدربين
                          لتحديد وتلبية احتياجاتهم التعليمية.
                        </li>
                        <li>
                          الغرض: تصميم برامج تدريبية لتلبية الاحتياجات المحددة
                          للمتدربين، وتعزيز تطورهم المهني.
                        </li>
                      </ul>
                    </Text>
                  </li>
                </ul>

                <Text size="lg" weight={700} style={{ margin: '1rem 0' }}>
                  الالتزامات بضمان النزاهة الأكاديمية في برامج التعلم الإلكتروني
                </Text>
                <ul
                  style={{
                    listStyle: 'inherit',
                    // margin: '16px 0px',
                    padding: '0px 40px 0px 0px',
                  }}
                >
                  <li>
                    <Text>
                      دقة البيانات:
                      <ul>
                        <li>
                          يجب على المتدربين التحقق من دقة بياناتهم قبل تقديم
                          الدفع لضمان المعالجة الصحيحة وحفظ السجلات.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      فهم السياسات والشروط:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يتعين على المتدربين قراءة وفهم السياسات والشروط
                          والأحكام قبل إكمال عملية الدفع لضمان الامتثال والوعي
                          بمسؤولياتهم.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      متطلبات الحضور والشهادة:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يجب على المتدربين قراءة وفهم نسبة الحضور المطلوبة
                          للحصول على الشهادة والساعات التعليمية اللازمة قبل
                          إجراء الدفع للتأكد من استيفائهم لجميع المتطلبات.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      تقييم رضا العملاء:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يتم توفير نموذج للمتدربين لتقييم مدى رضاهم عن الدورة،
                          مما يساعد في التحسين المستمر للجودة والنتائج
                          التعليمية.
                        </li>
                      </ul>
                    </Text>
                  </li>
                  <li>
                    <Text>
                      تحديد الاحتياجات التدريبية:
                      <ul
                        style={{
                          listStyle: 'inherit',
                          // margin: '16px 0px',
                          padding: '0px 40px 0px 0px',
                        }}
                      >
                        <li>
                          يتم منح المتدربين نموذج تحديد الاحتياجات التدريبية
                          لتحديد الأنشطة التي يرغبون في تطويرها، مما يمكن المركز
                          من تلبية احتياجاتهم التدريبية بشكل فعال.
                        </li>
                      </ul>
                    </Text>
                  </li>
                </ul>

                <Text size="lg" weight={700} style={{ margin: '1rem 0' }}>
                  تعد النزاهة الأكاديمية مبدأ أساسيًا في أكاديمية إنفينيتي
                  الطبية
                </Text>
                <Text>
                  ويشمل جوانب مختلفة بدءًا من إعداد المحتوى وحتى مشاركة
                  المتدربين. ومن خلال الالتزام بهذه المبادئ والالتزامات، تضمن
                  الأكاديمية بيئة تعليمية جديرة بالثقة وأخلاقية وعالية الجودة
                  تدعم التطوير المهني لممارسي الرعاية الصحية. لا يعزز هذا النهج
                  الشامل النزاهةالأكاديمية فحسب، بل يعزز أيضًا تجربة التعلم
                  الشاملة، مما يضمن حصول المتدربين على أفضل تعليم ممكن.
                </Text>
              </>
            </Col>
          </Grid>
        </Container>
      )}
    </>
  )
}

export default AcademicIntegrityContent
